module.exports = __webpack_public_path__ + "img/stage-new-leads.7e2b74ec.png";